export default __webpack_public_path__ + "static/media/star.8cc67955.svg";